import { VueConstructor } from "vue";
import { AddressInterface } from "@/api/Interfaces/AddressInterface";

function parsePhoneFormat(phone: string) {
  if (!phone) return "-";

  const phoneNumber = phone.replace(/\D/g, "");

  if (phoneNumber.length > 9) return phoneNumber.replace(/(\d{2})(\d{4,5})(\d{4})$/, "($1) $2-$3");
  if (phoneNumber.length == 9 || phoneNumber.length == 8 || phoneNumber.length == 7)
    return phoneNumber.replace(/(\d{3,5})(\d{4})$/, "$1-$2");
  if (phoneNumber.length == 6) return phoneNumber.replace(/(\d{3})(\d{3})$/, "$1-$2");

  return phoneNumber;
}

const toCurrency = (value: number) => {
  if (isNaN(value)) return "-";

  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });

  return formatter.format(value);
};

const toAddress = (address: AddressInterface) => {
  if (!address) return "-";

  const { street, neighbourhood, number, city, zip_code, complement } = address;

  return `${street}${number && number > 0 ? `, ${number}` : ""}${
    neighbourhood ? `, ${neighbourhood}` : ""
  }${complement ? `, ${complement}` : ""} ${city ? ` - ${city.name}` : ""}${
    city && city.state ? `/${city.state.abbreviation}` : ""
  }${zip_code ? ` - ${zip_code}` : ""}`;
};

const toPhone = (phones: string | string[]) => {
  if (!phones) return "-";

  if (typeof phones === "string") return parsePhoneFormat(phones);

  return phones.map((phone) => parsePhoneFormat(phone)).join(" | ");
};

const toRequired = (value: string, required: boolean) => {
  return (required ? "*" : "") + value;
};

export default {
  install(Vue: VueConstructor) {
    Vue.filter("toCurrency", toCurrency);
    Vue.filter("toAddress", toAddress);
    Vue.filter("toPhone", toPhone);
    Vue.filter("toRequired", toRequired);
  },
};
